function updateColorSchema(params) {
  const { colorSchemeMobile, colorSchemeDesktop, sectionElement } = params;

  const isMobile = window.innerWidth <= 749;
  if (sectionElement) {
    if (isMobile) {
      sectionElement.classList.add(colorSchemeMobile);
      sectionElement.classList.remove(colorSchemeDesktop);
    } else {
      sectionElement.classList.add(colorSchemeDesktop);
      sectionElement.classList.remove(colorSchemeMobile);
    }
  }
}

function changeColorSchema(params) {
  const { colorSchemeMobile, colorSchemeDesktop, sectionId } = params;

  const section = document.getElementById(sectionId);

  updateColorSchema({
    colorSchemeMobile,
    colorSchemeDesktop,
    sectionElement: section,
  });

  window.addEventListener('load', function () {
    const section = document.getElementById(sectionId);

    const updateSchema = () => {
      updateColorSchema({
        colorSchemeMobile,
        colorSchemeDesktop,
        sectionElement: section,
      });
    };

    window.addEventListener('resize', updateSchema);
  });
}
